import React, { useEffect, createElement } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { BenefitsSection } from '../BenefitsSection';
export const BenefitsPage = () => {
  useEffect(() => {
    document.title = 'Benefits — Maestro Connect';
    let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Discover the benefits of using Maestro Connect for your music teaching studio.';
  }, []);
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-3261">
      <Navbar data-id="element-3262" />
      <main className="pt-20" data-id="element-3263">
        <BenefitsSection data-id="element-3264" />
      </main>
      <Footer data-id="element-3265" />
    </div>;
};